import { gql } from '@apollo/client';

import { JobTitle } from '../profile/types/job-title';

export const GET_JOB_TITLES = gql`
  query getJobTitles($sortOrder: String, $sortField: String) {
    allJobTitles(sortOrder: $sortOrder, sortField: $sortField) {
      area
      deputy
      id
      order
      sourceDomains
      title
      trackingPriority
      typeOfEmployer
    }
  }
`;

export interface GetJobTitlesData {
  allJobTitles: (Required<Pick<JobTitle, 'area' | 'deputy' | 'id' | 'order' | 'title' | 'trackingPriority' | 'typeOfEmployer'>> &
    Pick<JobTitle, 'sourceDomains'>)[];
}
